import { IUser } from 'src/utils/interfaces/user';
import React from 'react';
import { useLocalization } from 'src/utils/useLocalization';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    getBrandByDealerNumber,
    getFooterLink,
    isSiteCanadian,
} from 'src/utils/helpers';

const FooterPrivacy: React.FC = () => {
    const { labelField } = useLocalization();
    const { i18n } = useTranslation();
    const lang = i18n?.language?.includes('fr') ? 'fr' : 'en';
    let brand = 'vw';
    const currentDealers = useSelector((state: IUser) => {
        return state.currentDealers;
    });
    const dealerDataInfo = useSelector((state: IUser) => {
        return state.dealerDataInfo;
    });
    if (currentDealers && dealerDataInfo) {
        const { dealer } = dealerDataInfo;
        brand = getBrandByDealerNumber(dealer.brand, dealer.dealerNumber);
    }
    const copyrightEntity = isSiteCanadian()
        ? 'VW Credit Canada, Inc.'
        : 'VW Credit USA, Inc.';
    const privacyUrl = getFooterLink('privacy', lang, true, brand);
    const usageUrl = getFooterLink('usage', lang);
    const contactUrl = getFooterLink('contact', lang, true, brand);

    return (
        <div className={'footer-privacy'}>
            <span className={'privacy_text'}>
                <a
                    className={'c-link'}
                    href={privacyUrl}
                    target='_blank'
                    rel='noreferrer'
                >
                    <span className='c-link__body  '>
                        <span className='c-link__effect'>
                            {labelField.LABEL_FIELD_PRIVACY_POLICY}
                        </span>
                    </span>
                </a>
                <span className={'u-ml-xxsmall u-mr-xxsmall'}>|</span>
                <a
                    className={'c-link'}
                    href={usageUrl}
                    target='_blank'
                    rel='noreferrer'
                >
                    <span className='c-link__body  '>
                        <span className='c-link__effect'>
                            {labelField.LABEL_FIELD_USAGE_AGREEMENT}
                        </span>
                    </span>
                </a>
                <span className={'u-ml-xxsmall u-mr-xxsmall'}>|</span>
                <a
                    className={'c-link'}
                    href={contactUrl}
                    target='_blank'
                    rel='noreferrer'
                >
                    <span className='c-link__body  '>
                        <span className='c-link__effect'>
                            {labelField.LABEL_FIELD_CONTACT_US}
                        </span>
                    </span>
                </a>
            </span>
            <span className={'u-text-muted u-mt-xsmall rights_text'}>
                &copy; {new Date().getFullYear()} {copyrightEntity} All rights
                reserved.
            </span>
        </div>
    );
};

export default FooterPrivacy;
